import React from 'react';
import { createRoot } from 'react-dom/client';
import { PlatformShell } from './shell/PlatformShell';
import './styles.css';
import './presentation/experience.css';
createRoot(document.getElementById('root')!).render(<React.StrictMode><PlatformShell /></React.StrictMode>);
